module.exports = __webpack_public_path__ + "static/media/aa.500ba4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aa.jpg
// module id = 5759
// module chunks = 0